import * as FileSaver from "file-saver";
import React from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import ChangeBoxOrder from "../../../components/OrderGrid/ChangeOrder/ChangeBoxOrder";
import ChangeOrder from "../../../components/OrderGrid/ChangeOrder/ChangeOrder";
import History from "../../../components/OrderGrid/History/History";
import PasswordReq from "../../../components/OrderGrid/PasswordReq/PasswordReq";
import Button from "../../../components/UI/Button/Button";
import DatePicker from "../../../components/UI/DatePicker/DatePicker";
import Input from "../../../components/UI/Input/Input";
import Modal from "../../../components/UI/Modal/Modal";
import Search from "../../../components/UI/Search/Search";
import Select from "../../../components/UI/Select/Select";
import Table from "../../../components/UI/Table/Table";
import FetchData from "../../../shared/fetchData";
import { updateObject } from "../../../shared/utility";
import CancelOrder from "../../Orders/operations/CancelOrder";
import ShowPassword from "../../Orders/operations/ShowPassword";
import "./Orders.css";

const Orders = (props) => {
  const [from, setFrom] = React.useState("");
  const [to, setTo] = React.useState("");
  const [pageCount, setPageCount] = React.useState(0);
  const [orders, setOrders] = React.useState([]);
  const [rerender, setRerender] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [searchParams, setSearchParams] = React.useState({
    orderNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره سفارش",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
    courierTrackNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شناسه سفارش دهنده",
      },
      validation: {},
      errorMessage: "",
      valid: true,
      value: "",
    },
  });
  const [orderState, setOrderState] = React.useState("");
  const [orderStates, setOrderStates] = React.useState([
    {
      value: "R",
      label: "ثبت شده",
    },
    {
      value: "F",
      label: "نهایی شده",
    },
  ]);
  const [modalContent, setModalContent] = React.useState("");
  const [kiosks, setKiosks] = React.useState([]);
  const [kiosk, setKiosk] = React.useState("");
  const [lockerTypes, setLockerTypes] = React.useState([]);
  const [lockerType, setLockerType] = React.useState("");
  const [users, setUsers] = React.useState([]);
  const [user, setUser] = React.useState("");
  const childRef = React.useRef();

  React.useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    const search = searchParams;
    for (let key in search) {
      search[key].value = "";
    }
    setSearchParams(search);
    setOrderState("");
    const fromDate = new URLSearchParams(window.location.search).get("from");
    const toDate = new URLSearchParams(window.location.search).get("to");
    setFrom(fromDate);
    setTo(toDate);
    var raw = JSON.stringify({
      kiosk: {},
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });

    var url = "management/api/v1/kiosks/getKiosks";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setKiosks(result.kiosks);
        }
      })
      .catch((error) => console.log(error));
    var raw = JSON.stringify({
      lockerType: {},
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });

    var url = "management/api/v1/lockertypes/getLockerTypes";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setLockerTypes(result.lockerTypes);
        }
      })
      .catch((error) => console.log(error));

    var rawMyUsers = JSON.stringify({
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    FetchData(rawMyUsers, "management/api/v1/users/getMyUsers")
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setUsers(result.users);
        }
      })
      .catch((error) => console.log(error));
  }, []);

  const getUserDisplay = (userInfo) => {
    if (
      userInfo == null ||
      userInfo.username == null ||
      userInfo.username === ""
    ) {
      return "-";
    }
    return userInfo.username;
  };

  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            filter: {
              fromDate: from != null && from != "" ? from : null,
              toDate: to != null && to != "" ? to : null,
              orderNumber:
                searchParams["orderNumber"].value !== ""
                  ? "%" + searchParams["orderNumber"].value + "%"
                  : null,
              courierTrackNumber:
                searchParams["courierTrackNumber"].value !== ""
                  ? "%" + searchParams["courierTrackNumber"].value + "%"
                  : null,
              orderState:
                orderState != null && orderState != ""
                  ? orderState.value
                  : null,
              lockerType:
                lockerType != null && lockerType != ""
                  ? lockerType.value
                  : null,
              kiosk: kiosk != null && kiosk != "" ? kiosk.value : null,
              userId: user != null && user != "" ? user.value : null,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });

    var url = "management/api/v1/orders/searchMyOrdersByFilter";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.orders);
          pushData(newList);
          setOrders(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };

  const showHistoriesHandler = (orderId) => {
    var info = {
      order: {
        id: orderId,
      },
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/orders/getOrderInfo";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          if (
            result.order.histories != null &&
            result.order.histories?.length > 0
          ) {
            setModalContent(
              <>
                {result.order.histories?.map((h) => {
                  return <History history={h} />;
                })}
              </>
            );
            childRef.current.openModal();
          } else {
            setModalContent(
              <>هیچ تاریخچه ای برای رکورد مورد نظر ثبت نشده است</>
            );
            childRef.current.openModal();
          }
        }
        setLoading(false);
      })
      .catch((error) => setLoading(false));
  };

  const cancelOrder = (id) => {
    setModalContent(
      <CancelOrder
        back={() => childRef.current.closeModal()}
        closeModalAndUpdateGrid={() => {
          childRef.current.closeModal();
          getData({ pageIndex: pageIndex, pageSize: pageSize });
        }}
        orderId={id}
      />
    );
    childRef.current.openModal();
  };
  const passwordRequest = (id, data) => {
    const pass = data.filter((p) => p.id === id);
    if (!!pass && pass.length > 0) {
      setModalContent(
        <PasswordReq
          closeModal={() => childRef.current.closeModal()}
          orderNumber={pass[0].orderNumber}
        />
      );
      childRef.current.openModal();
    }
  };

  const showPasswords = (id) => {
    setModalContent(
      <ShowPassword
        orderId={id}
        closeModal={() => childRef.current.closeModal()}
      />
    );
    childRef.current.openModal();
  };
  const changeOrder = (id, data) => {
    const ord = data?.filter((e) => e.id === id);
    if (!!ord) {
      setModalContent(
        <ChangeOrder
          order={ord[0]}
          closeAndReload={() => {
            childRef.current.closeModal();
            getData({ pageIndex: pageIndex, pageSize: pageSize });
          }}
          handleClose={() => childRef.current.closeModal()}
        />
      );
      childRef.current.openModal();
    }
  };
  const changeOrderBox = (id, data) => {
    const ord = data?.filter((e) => e.id === id);
    if (!!ord) {
      setModalContent(
        <ChangeBoxOrder
          order={ord[0]}
          closeAndReload={() => {
            childRef.current.closeModal();
            getData({ pageIndex: pageIndex, pageSize: pageSize });
          }}
          handleClose={() => childRef.current.closeModal()}
        />
      );
      childRef.current.openModal();
    }
  };
  const adminOpenSubmit = (id) => {
    var info = {
      order: {
        id: id,
      },
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/orders/adminOpenOrder";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "0") {
          childRef.current.closeModal();
        }
      })
      .catch((error) => console.log(error));
  };
  const adminOpenOrder = (id, ord) => {
    setModalContent(
      <>
        <div className="row justify-content-center">
          از ثبت باز کردن لاکر توسط ادمین مطمئن هستید؟
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-6 text-center">
            <Button btnType="Success" clicked={() => adminOpenSubmit(id)}>
              بله
            </Button>
          </div>
          <div className="col-6 text-center">
            <Button
              btnType="General"
              clicked={() => childRef.current.closeModal()}
            >
              خیر
            </Button>
          </div>
        </div>
      </>
    );
    childRef.current.openModal();
  };

  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "orderNumber",
        header: "شمازه سفارش",
        align: "center",
      },
      {
        accessorKey: "registerDate",
        header: "تاریخ ثبت",
        align: "center",
      },
      {
        accessorKey: "startDate",
        header: "از تاریخ",
        align: "center",
      },
      {
        accessorKey: "endDate",
        header: "تا تاریخ",
        align: "center",
      },
      {
        accessorKey: "unitName",
        header: "حساب",
        align: "center",
      },
      {
        accessorKey: "userDisplay",
        header: "اکانت",
        align: "center",
      },
      {
        accessorKey: "courierTrackNumber",
        header: "شناسه سفارش دهنده",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        orderNumber: d.orderNumber,
        registerDate: d.registerDate,
        startDate: d.startDate,
        endDate: d.endDate,
        unitName: !!d.unit ? d.unit.unitName : "-",
        userDisplay: getUserDisplay(d.user),
        courierTrackNumber: d.courierTrackNumber,
        subRows: [
          { header: "از ساعت", value: d.startTime },
          { header: "تا ساعت", value: d.endTime },
          { header: "سریال باکس", value: !!d.locker ? d.locker.serial : "" },
          { header: "نام باکس", value: !!d.kiosk ? d.kiosk.description : "" },
          {
            header: "هزینه باکس",
            value: !!d.lockerAmount
              ? d.lockerAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "-",
          },
          {
            header: "مالیات",
            value: !!d.taxAmount
              ? d.taxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "-",
          },
          {
            header: "هزینه نهایی",
            value: !!d.finalAmount
              ? d.finalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "-",
          },
          {
            header: "سرویس جمع آوری/بارگذاری",
            value:
              !!d.needFirstMile && d.needFirstMile == "1" ? "دارد" : "ندارد",
          },
          {
            header: "شناسه محل جمع آوری",
            value: !!d.pickupId ? d.pickupId : "",
          },
          {
            header: "کد رهگیری سفارش جمع آوری",
            value: !!d.tinextTrackNumber ? d.tinextTrackNumber : "",
          },
          {
            header: "سرویس تخلیه",
            value: !!d.needLastMile && d.needLastMile == "1" ? "دارد" : "ندارد",
          },
          {
            header: "شناسه محل تخلیه",
            value: !!d.deliverId ? d.deliverId : "",
          },
          {
            header: "کد رهگیری سفارش تخلیه",
            value: !!d.tinextTrackNumberLastMile
              ? d.tinextTrackNumberLastMile
              : "",
          },
          {
            header: "شماره سفارش مقصد لاکر به لاکر",
            value: !!d.destinationOrderNumber ? d.destinationOrderNumber : "",
          },
        ],
      });
    });
    const prmsn = window.localStorage.getItem("permission");
    if (
      prmsn.split(",").includes("CUSTOMER_WRITE") ||
      prmsn.split(",").includes("ORDER_WRITE")
    ) {
      buttons.push({ id: 1, text: "کنسل کردن", clicked: cancelOrder });
      buttons.push({ id: 3, text: "درخواست رمز", clicked: passwordRequest });
    }
    buttons.push({
      id: 2,
      text: "مشاهده تاریخچه",
      clicked: showHistoriesHandler,
    });
    buttons.push({ id: 4, text: "مشاهده رمز", clicked: showPasswords });
    if (prmsn.split(",").includes("CHANGE_WRITE")) {
      buttons.push({ id: 5, text: "تغییر بازه سفارش", clicked: changeOrder });
      buttons.push({
        id: 6,
        text: "جابجایی لاکر سفارش",
        clicked: changeOrderBox,
      });
      buttons.push({
        id: 7,
        text: "ثبت باز کردن لاکر توسط",
        clicked: adminOpenOrder,
      });
    }
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };

  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };
  const changeFromDate = (unix, formatted) => {
    setFrom(formatted);
  };

  const changeToDate = (unix, formatted) => {
    setTo(formatted);
  };

  const changeOrderState = (selectedOption) => {
    setOrderState(selectedOption);
  };

  const refresh = (event) => {
    setFrom("");
    setTo("");
    setKiosk("");
    setUser("");
    setLockerType("");
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setOrderState("");
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };
  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }

  const afterCloseModal = (event) => {};

  const exportToCSV = (event) => {
    var raw = JSON.stringify({
      filter: {
        fromDate: from != null && from != "" ? from : null,
        toDate: to != null && to != "" ? to : null,
        orderNumber:
          searchParams["orderNumber"].value !== ""
            ? "%" + searchParams["orderNumber"].value + "%"
            : null,
        courierTrackNumber:
          searchParams["courierTrackNumber"].value !== ""
            ? "%" + searchParams["courierTrackNumber"].value + "%"
            : null,
        orderState:
          orderState != null && orderState != "" ? orderState.value : null,
        lockerType:
          lockerType != null && lockerType != "" ? lockerType.value : null,
        kiosk: kiosk != null && kiosk != "" ? kiosk.value : null,
        userId: user != null && user != "" ? user.value : null,
      },
      pl: "1048576",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/orders/searchMyOrdersByFilter";
    setLoading(true);
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          let exportOrder = [];
          let count = 0;
          const order = result.orders.map((o) => {
            count++;
            exportOrder.push({
              ردیف: count,
              "شماره سفارش": o.orderNumber,
              "تاریخ ثبت": o.registerDate,
              حساب: o.unit != null ? o.unit.unitName : "",
              اکانت: getUserDisplay(o.user),
              "شناسه سفارش دهنده": o.courierTrackNumber,
              "تاریخ شروع": o.startDate,
              "ساعت شروع": o.startTime,
              "تاریخ پایان": o.endDate,
              "ساعت پایان": o.endTime,
              "هزینه باکس": o.lockerAmount,
              مالیات: o.taxAmount,
              "هزینه نهایی": o.finalAmount,
              "دلیل کنسلی": o.cancelReason,
              "سرویس جمع آوری/بارگذاری":
                !!o.needFirstMile && o.needFirstMile == "1" ? "دارد" : "ندارد",
              "شناسه محل جمع آوری": !!o.opickupId ? o.pickupId : "",
              "کد رهگیری سفارش جمع آوری": !!o.tinextTrackNumber
                ? o.tinextTrackNumber
                : "",
              "سرویس تخلیه":
                !!o.needLastMile && o.needLastMile == "1" ? "دارد" : "ندارد",
              "شناسه محل تخلیه": !!o.deliverId ? o.deliverId : "",
              "کد رهگیری سفارش تخلیه": !!o.tinextTrackNumberLastMile
                ? o.tinextTrackNumberLastMile
                : "",
              "شماره سفارش مقصد لاکر به لاکر": !!o.destinationOrderNumber
                ? o.destinationOrderNumber
                : "",
            });
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(exportOrder);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "Orders" + fileExtension);
        }
      })
      .catch((error) => setLoading(false));
  };

  const changeKiosk = (selectedOption) => {
    setKiosk(selectedOption);
  };

  const changeUser = (selectedOption) => {
    setUser(selectedOption);
  };

  const changeLockerType = (selectedOption) => {
    setLockerType(selectedOption);
  };

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });

  const kioskList = [];
  if (kiosks != null && kiosks.length != 0) {
    kiosks.map((z) => {
      kioskList.push({
        value: z.id,
        label: z.description,
      });
    });
  }
  const lockerTypeList = [];
  if (lockerTypes != null && lockerTypes.length != 0) {
    lockerTypes.map((z) => {
      lockerTypeList.push({
        value: z.id,
        label: z.description,
      });
    });
  }

  const userList = [];
  if (users != null && users.length != 0) {
    users.map((z) => {
      userList.push({
        value: z.username,
        label: z.username,
      });
    });
  }

  form = (
    <div>
      <div className="row pl-4" dir="ltr"></div>
      <div className="row pl-4" dir="ltr">
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">
        {form}
        <div className="col-3 full-small">
          <DatePicker
            change={changeFromDate}
            value={from}
            placeHolder="از تاریخ"
          />
        </div>
        <div className="col-3 full-small">
          <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
        </div>
        <Select
          name="form-field-name"
          value={orderState}
          placeholder="وضعیت سفارش"
          options={orderStates}
          onChange={changeOrderState}
          col="3"
        />
        <Select
          name="form-field-name"
          value={kiosk}
          placeholder="لاکر"
          options={kioskList}
          onChange={changeKiosk}
          col="3"
        />
        <Select
          name="form-field-name"
          value={user}
          placeholder="اکانت"
          options={userList}
          onChange={changeUser}
          col="3"
        />
        <Select
          name="form-field-name"
          value={lockerType}
          placeholder="نوع باکس"
          options={lockerTypeList}
          onChange={changeLockerType}
          col="3"
        />
      </div>
      <div className="row text-left" dir="ltr">
        <div className="col-2 ord-small-btns">
          <Button btnType="search-btn" clicked={search}>
            <span className="tab-color">جستجو</span>
          </Button>
        </div>
        <div className="col-6 text-left ord-small-btns">
          <Button btnType="Search" clicked={exportToCSV}>
            <span className="tab-color">گزارشگیری</span>
          </Button>
        </div>
      </div>
    </div>
  );
  return (
    <div className="third-orders">
      <Search class="orders-search" form={form} />
      <div className="row justify-content-center w-100 ml-0 mr-0">
        {rerender ? (
          // <Spinner />
          <Table
            pageSize={pageSize}
            data={orders}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        ) : (
          <Table
            pageSize={pageSize}
            data={orders}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={170}
            loading={loading}
          />
        )}
      </div>
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </div>
  );
};
export default Orders;
